import { Link } from 'react-router-dom';
import { sportCategories } from '@/mocks/sports';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <Link to="/" className="inline-block cursor-pointer">
                <span className="font-heading text-xl font-bold text-accent-500">开云爱体育</span>
              </Link>
              <p className="mt-4 text-sm text-foreground-300 leading-relaxed">
                开云爱体育是专业体育竞技娱乐平台，汇聚全球顶级赛事资源，提供多元化体育项目体验。加入开云爱体育，享受极致竞技乐趣。
              </p>
              <div className="flex items-center gap-3 mt-5">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-accent-500 transition-colors cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line text-sm"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-accent-500 transition-colors cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line text-sm"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-accent-500 transition-colors cursor-pointer" aria-label="抖音">
                  <i className="ri-tiktok-line text-sm"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-white mb-5">体育分类</h4>
              <ul className="space-y-3">
                {sportCategories.slice(0, 4).map(cat => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-foreground-300 hover:text-accent-500 transition-colors cursor-pointer"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-white mb-5">快速链接</h4>
              <ul className="space-y-3">
                <li>
                  <Link to="/" className="text-sm text-foreground-300 hover:text-accent-500 transition-colors cursor-pointer">首页</Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-foreground-300 hover:text-accent-500 transition-colors cursor-pointer">关于我们</Link>
                </li>
                <li>
                  <Link to="/category/football" className="text-sm text-foreground-300 hover:text-accent-500 transition-colors cursor-pointer">足球赛事</Link>
                </li>
                <li>
                  <Link to="/category/basketball" className="text-sm text-foreground-300 hover:text-accent-500 transition-colors cursor-pointer">篮球赛事</Link>
                </li>
                <li>
                  <Link to="/category/esports" className="text-sm text-foreground-300 hover:text-accent-500 transition-colors cursor-pointer">电竞资讯</Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-white mb-5">联系我们</h4>
              <ul className="space-y-3">
                <li className="flex items-start gap-2 text-sm text-foreground-300">
                  <i className="ri-mail-line mt-0.5 text-accent-500"></i>
                  <span>contact@kaiyunsports.com</span>
                </li>
                <li className="flex items-start gap-2 text-sm text-foreground-300">
                  <i className="ri-phone-line mt-0.5 text-accent-500"></i>
                  <span>400-888-9999</span>
                </li>
                <li className="flex items-start gap-2 text-sm text-foreground-300">
                  <i className="ri-map-pin-line mt-0.5 text-accent-500"></i>
                  <span>北京市朝阳区建国路88号</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-foreground-800">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-xs text-foreground-400">
                &copy; {currentYear} 开云爱体育 版权所有 | 京ICP备2024000001号
              </p>
              <div className="flex items-center gap-6">
                <a href="#" className="text-xs text-foreground-400 hover:text-accent-500 transition-colors cursor-pointer">隐私政策</a>
                <a href="#" className="text-xs text-foreground-400 hover:text-accent-500 transition-colors cursor-pointer">服务条款</a>
                <a href="#" className="text-xs text-foreground-400 hover:text-accent-500 transition-colors cursor-pointer">免责声明</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}